// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 885); hand-edits allowed (see docs/architecture.md)

/** `this.WORLD_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_WORLD_DEF(): any {
  return {
    "wormville": {
      "pos": 1,
      "tasks": new Array<any>(15, "mission1", "mission2", "mission3", "mission4", "mission5", "career1", "career2", "career3", "career4", "career5", "career6", "career7", "career8", "career9", "career10"),
      "name": "Вормвилль",
      "coord_x": 5,
      "coord_y": 4,
      "shop": false
    },
    "papa_john": {
      "pos": 2,
      "tasks": new Array<any>(1, "john"),
      "name": "Магазин Папы Джона",
      "coord_x": 13,
      "coord_y": 2,
      "shop": true
    }
  };
}
